import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getStlifeImagesById } from '../../store/thunks/studentLifeThunk';
import DataTable from 'react-data-table-component';
import { updateStatusStLifeImage } from '../../services/studentLife';
import { setData } from '../../store/slices/studentLifeImagesSlice';
import { logout } from '../../store/thunks/authThunks';

const StudentLifeImages = () => {
    const { id, title } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth.token);
    const { list, total, loading, error } = useSelector((state) => state.studentLifeImages);
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;
    
    useEffect(() => {
          if (token) {
            dispatch(getStlifeImagesById(id));
          }    
    }, [dispatch, token]);

    useEffect(() => {
      if(error && error.toLowerCase()==='invalid token'){
        handleLogout();
      }    
    }, [error]);

    const columns = [
    { name: 'Image Name', selector: (row) => row.name, sortable: true },
    { name: 'Active', selector: (row) => row.active, sortable: false, cell: (row) => (
      <label className="inline-flex items-center cursor-pointer relative">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={row.active}
          onChange={() => handleToggle(row)}
        />
        <div className="w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-green-500 transition-colors"></div>
        <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
      </label>
    ) }
  ];

  const handleToggle = async (row) => {
    await updateStatusStLifeImage(id, row, token.token)
            .then(response=>{
              if(response?.data?.success){
                const updatedList = list.map(item => 
                  item._id === row._id ? { ...item, active: !item.active } : item
                );
            
                dispatch(setData({data: updatedList, total: total}))
              }
            })
            .catch(error=>{
              dispatch(setData({data: list, total: total}))
              console.log(error);
            });
  };

  const handleLogout = () => {
      dispatch(logout());
      navigate('/login');
    };

  const handleAddImage = () => {
      navigate('/student-life/add-images', { state: { id, title } }); // or open modal instead
  };

  return (
    <div>
      {loading && (
        <div className="absolute inset-0 bg-white bg-opacity-60 flex items-center justify-center z-50">
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500"></div>
        </div>
      )}
      <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <div className="text-sm text-gray-500">
              <span className="text-blue-600 cursor-pointer" onClick={() => navigate('/student-life')}>
                Student Life
              </span>
              &gt; {title} &gt; Images
            </div>
            <div>
              <button
                onClick={() => handleAddImage()}
                className="bg-blue-600 text-white px-4 py-2 mr-4 rounded hover:bg-blue-700 transition cursor-pointer"
              >
                + Add Image
              </button>
              <button
                className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 cursor-pointer"
                onClick={() => navigate('/student-life')}
              >
                Back to List
              </button>
            </div>            
          </div>
          <DataTable
            columns={columns}
            data={list}
            progressPending={loading}
            pagination
            paginationPerPage={rowsPerPage}
            paginationTotalRows={total}
            onChangePage={(page) => setPage(page)}
            highlightOnHover
            pointerOnHover
            striped
          />
      </div>
    </div>
  )
}

export default StudentLifeImages
